// ===========================================
// BUSTED! BLACKJACK - CONNECTION STATUS HOOK
// ===========================================

import { useState, useEffect, useCallback } from 'react';
import { api } from '../api';

interface ConnectionStatus {
  isConnected: boolean;
  isChecking: boolean;
  lastCheck: Date | null;
  services: {
    database: 'ok' | 'error' | 'unknown';
    redis: 'ok' | 'error' | 'unknown';
    websocket: 'ok' | 'error' | 'unknown';
  };
}

export function useConnectionStatus(checkInterval = 30000) {
  const [status, setStatus] = useState<ConnectionStatus>({
    isConnected: false,
    isChecking: true,
    lastCheck: null,
    services: {
      database: 'unknown',
      redis: 'unknown',
      websocket: 'unknown',
    },
  });

  const checkHealth = useCallback(async () => {
    setStatus(prev => ({ ...prev, isChecking: true }));
    
    try {
      const result = await api.health.check();
      
      if (result.success && result.data) {
        setStatus({
          isConnected: result.data.status === 'ok',
          isChecking: false,
          lastCheck: new Date(),
          services: result.data.services,
        });
      } else {
        setStatus({
          isConnected: false,
          isChecking: false,
          lastCheck: new Date(),
          services: {
            database: 'error',
            redis: 'error',
            websocket: 'error',
          },
        });
      }
    } catch {
      setStatus({
        isConnected: false,
        isChecking: false,
        lastCheck: new Date(),
        services: {
          database: 'error',
          redis: 'error',
          websocket: 'error',
        },
      });
    }
  }, []);
  
  // Initial check and periodic checks
  useEffect(() => {
    checkHealth();
    
    const interval = setInterval(checkHealth, checkInterval);
    return () => clearInterval(interval);
  }, [checkHealth, checkInterval]);
  
  return { ...status, refresh: checkHealth };
}

export default useConnectionStatus;
